import { useRef, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useNavigationManager } from '@provider/navigation';
import { TabSection } from '@ui/kit';
import { useChangeEffect, CSSRefTransition } from '@utils/react';
import { useCurrentTask } from '../util.get-current-task.js';
import { transitionDurationMs, iguideWrapper, section, iguide } from './variant.standalone.style.js';
import { jsx } from 'react/jsx-runtime';
import { IGuideContentRoot } from '../organism.content/organism.root.js';

function StandaloneWrapper(props) {
  const ref = useRef(null);
  const navigation = useNavigationManager();
  const currentTask = useCurrentTask(props.component.data, props.component.entryKey);
  useEffect(() => {
    if (props.context == "lightbox") {
      return;
    }
    return navigation.subscribe(() => {
      if (props.context === "lightbox") {
        props.rootRef.current?.scrollIntoView({
          block: "start",
          behavior: "auto"
        });
      } else {
        window.scrollTo(0, 0);
      }
    });
  }, [navigation, props.context, props.rootRef]);
  useChangeEffect(() => {
    setTimeout(() => {
      const taskRoot = ref.current?.querySelector("[data-task-root]");
      taskRoot?.focus({
        preventScroll: true
      });
    }, transitionDurationMs + 50);
  }, [currentTask?.index]);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: iguideWrapper,
    "data-context": props.context,
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: transitionDurationMs,
        classNames: section,
        delayMs: {
          enter: 10,
          exit: 0
        },
        mountOnEnter: true,
        unmountOnExit: true,
        children: ref => /*#__PURE__*/jsx(TabSection, {
          ref: ref,
          className: section,
          disabled: props.component.data.tasks.length === 1,
          baseId: props.tabId,
          selectedTabId: currentTask.task?.id,
          children: /*#__PURE__*/jsx(IGuideContentRoot, {
            className: iguide,
            currentTaskIndex: currentTask.index,
            component: props.component,
            onNavigateTo: props.onNavigateTo,
            onResetEntry: props.onResetEntry,
            context: props.context
          })
        })
      }, currentTask.index)
    })
  });
}

export { StandaloneWrapper };
//# sourceMappingURL=variant.standalone.js.map
